import React, { useEffect, useRef, useState } from "react";
import Avatar from "../static/images/avata.svg";

export default function CarRegNumberPage({ isSales,
    skipVerifyingCarReg,
    setSkipVerifyingCarReg,
    restartChat,
    OPTVerified,
    carRegNo,
    setCarRegNo,
    carNoValid,
    setCarNoValid,
    loading,
    setLoading
}) {
    useEffect(() => {
        if (OPTVerified) {
            if (skipVerifyingCarReg) {
                restartChat()
            }
        }
    }, [skipVerifyingCarReg])

    const miniMize = (e) => {
        console.log("minimizing ini");
        if (window && window.parent) {
            console.log("minimizing start");
            window.parent.postMessage({ message: 'Box minimize.', minimize: true }, '*');
        } else {
            console.log("minimizing not  start");
        }
    }
    const validateCarRegNo = (carNo) => {
        carNo = carNo.replace(/\-+/g, '');
        if (/^[A-Z]{2}[ -]{0,1}[0-9]{2}[ -]{0,1}[0-9]{4}$/.test(carNo)) {
            return true;
        } else if (/^[A-Z]{2}[0-9]{1,2}[A-Z]{1,3}[0-9]{4}$/.test(carNo)) {
            return true;
        } else if (/^[2-9]{1}[0-9]{1}BH[0-9]{4}[A-HJ-NP-Z]{1,2}$/.test(carNo)) {
            return true;
        } else {
            return false;
        }
    }
    const handleInputChange = (event) => {
        const value = event.target.value;
        if (value) {
            setCarRegNo(value.toUpperCase());
        }
        setCarNoValid(validateCarRegNo(value));
    };
    const handleSkipClick = () => {
        setCarNoValid(false);
        setCarRegNo(null)
        setSkipVerifyingCarReg(true)
    }
    const submitCarRegNo = () => {
        if (carRegNo && carNoValid) {
            setLoading(true)
            setSkipVerifyingCarReg(true)
        }
    }

    return (
        <>
            <div id="container" className={`${isSales ? "" : 'lightblue'}`}>

                <div id="chat-frame" className={`${isSales ? "mini" : ''}`}>
                    <header>
                        <span onClick={() => miniMize()} class="close"></span>
                        <div class="heading-with-icon">
                            <img src={Avatar} class="chaticon"><img /></img>
                            <div class="titlewrap">
                                <div class="title">Welcome to PB Chat
                                </div>
                            </div>
                        </div>
                    </header>

                    <div class="chatbox-container">
                        <div class="step-1">
                            <div class="card">
                                <h3>Verify your Registered Car Number</h3>

                                <div class="registration_check">
                                    <div class="formInput">
                                        <input type="text"
                                            class="full labelshow" maxlength="30" value={carRegNo || null} placeholder="Enter Car Registration Number ..." onChange={(event) => handleInputChange(event)} />
                                        <label class="feildLable" for="policy-no"></label>
                                    </div>
                                </div>
                                <button className={`${!carNoValid ? "button disabledBtn" : 'button'} ${loading ? "loading" : ""}`} onClick={() => submitCarRegNo()} disabled={!carNoValid}>Submit</button>
                                <span class="link">
                                    <span onClick={handleSkipClick}>Skip</span>
                                </span>
                            </div>
                        </div>
                    </div >


                </div>

            </div>
        </>
    );
}
